module.exports = __webpack_public_path__ + "static/media/CUF.0958ba09.pdf";